import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';

import { LayoutService } from '../services/layout.service';

@Directive({
  selector: '[updateSection]',
})
export class UpdateSectionDirective implements OnInit, OnDestroy {

  private subscription: Subscription;

  public constructor(private layoutService: LayoutService, private renderer: Renderer2, private el: ElementRef) {
    this.subscription = new Subscription();
  }

  /**
   * Desc
   */
  public ngOnInit() {

    this.subscription.add(
      this.layoutService.changeSectionClass
      .subscribe(
        (sectionClass: string) => {
          const updatedSectionClass = sectionClass ? 'page-section ' + sectionClass : sectionClass;
          this.renderer.setAttribute(
            this.el.nativeElement,
            'class',
            updatedSectionClass,
          );
        },
      ),
    );

    this.subscription.add(
      this.layoutService.addSectionClass
      .subscribe(
        (addedSectionClass: string) => {
          if (addedSectionClass !== null) {
            this.renderer.addClass(this.el.nativeElement, addedSectionClass);
          }

        },
      ),
    );
  }

  /**
   * Desc
   */
  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
